import { useEffect } from 'react';
import snakeCase from 'lodash/snakeCase';

import { IConstructorSortOption } from 'shared/types/ConstructorSortOption';
import { CheckboxRadio } from 'shared/components/CheckboxRadio';
import { getConstructorSortStrings } from 'search/enums/translations';

interface ISearchSingleSelect {
  name: string;
  options: Array<IConstructorSortOption>;
  selectedOption: IConstructorSortOption;
  setSelectedOption: (option: IConstructorSortOption) => void;
}

export const SearchSingleSelect = ({
  name,
  options,
  selectedOption,
  setSelectedOption,
}: ISearchSingleSelect) => {
  const handleChange = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    const initialSelected = options.find((option) => option.status === 'selected');
    setSelectedOption(initialSelected);
  }, [options]);

  return (
    <>
      {options.map((option) => (
        <CheckboxRadio
          checked={selectedOption?.display_name === option.display_name}
          data-qa={`${snakeCase(option.display_name)}_radio_option`}
          key={`${option.display_name}${option.sort_by}`}
          label={getConstructorSortStrings(option.display_name)}
          name={name}
          onChange={() => handleChange(option)}
          type="radio"
        />
      ))}
    </>
  );
};
